import { EMBLEMS } from '../modes/match/matchConfig';
import { MatchGame } from '../modes/match/MatchGame';

export function EmblemsRoute() {
  return <MatchGame config={EMBLEMS} />;
}
